/* eslint-disable react-hooks/exhaustive-deps */
"use client"

import React, { useRef, useMemo, useCallback } from "react"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
import { Bar } from 'react-chartjs-2'
import { Box, makeStyles, Paper, Typography } from "@material-ui/core"

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

const useStyles = makeStyles((theme) => ({
  root: {
      flexGrow: 1,
      padding: theme.spacing(3),
      backgroundColor: "#f5f5f5",
      minHeight: "100vh",
  },
  paper: {
      padding: theme.spacing(2),
      height: 300,
  },
  title: {
      fontSize: "0.9rem",
      color: "#1976d2",
      marginBottom: theme.spacing(1),
  },
  chartContainer: {
      height: "calc(100% - 40px)",
  },
}))

const VerticalBarChart = ({
  title,
  selectedCoin,
  selectedRow,
  setSelectedRow,
  data,
  handleRowDoubleClick,
  options,
}) => {
  const classes = useStyles()
  const chartRef = useRef();
  const clickCountRef = useRef(0);
  const timeoutRef = useRef(null);
  const lastElementRef = useRef(null);

  const handleRowClick = (id) => {
    if (!setSelectedRow) {
      return;
    }
    if (selectedRow === id) {
      setSelectedRow('');
    } else {
      setSelectedRow(id);
    }
  };
  
  const handleChartClick = useCallback((event, elements) => {
    if (elements.length === 0) return;

    const element = elements[0];
    const index = element.index;

    clickCountRef.current++;

    if (clickCountRef.current === 1) {
      console.log("is simple")
      timeoutRef.current = setTimeout(() => {
        if (clickCountRef.current === 1 && handleRowClick) {
          // handleRowClick(item.id);
        }
        clickCountRef.current = 0;
        lastElementRef.current = null;
      }, 300);
    } else if (clickCountRef.current === 2) {
      clearTimeout(timeoutRef.current);
      console.log("is double")
      if (lastElementRef.current === index && handleRowDoubleClick) {
        const clickedData = {
          index: index,
          label: data.labels ? data.labels[index] : null,
          value: data.datasets && data.datasets[0] ? data.datasets[0].data[index] : null,
          datasetIndex: element.datasetIndex,
          element: element
        };
        handleRowDoubleClick(clickedData);
      }
      
      clickCountRef.current = 0;
      lastElementRef.current = null;
    }

    lastElementRef.current = index;
  }, [data, handleRowClick, handleRowDoubleClick]);

  const defaultOptions = useMemo(() => ({
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            return `${context.dataset.label}: ${context.parsed.y}%`;
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        max: 100,
        ticks: {
          callback: function(value) {
            return value + '%';
          }
        }
      },
    },
    onClick: handleChartClick,
    interaction: {
      intersect: false,
      mode: 'index',
    },
    elements: {
      bar: {
        hoverBackgroundColor: '#8e44ad',
      }
    }
  }), [handleChartClick]);

  const mergedOptions = useMemo(() => ({
    ...defaultOptions,
    ...options,
    onClick: handleChartClick,
  }), [defaultOptions, options, handleChartClick]);

  return (
    <Paper className={classes.paper}>
      <Typography variant="h6" className={classes.title}>
        {title}
      </Typography>
      <Box className={classes.chartContainer}>
        <Bar 
          data={data} 
          options={mergedOptions} 
          ref={chartRef}
        />
      </Box>
    </Paper>
  )
}

export default VerticalBarChart;